<div
  #mapTarget
  class="fms-diagnose-map"
  data-test="fms-diagnose-map"
  role="application"
  [attr.aria-label]="ariaLabel"
>
  <div class="map-controls" data-test="fms-diagnose-map-controls">
    <button
      class="map-control"
      type="button"
      (click)="centerMap()"
      [attr.aria-label]="'fmsDiagnose.tabs.cropFields.map.center' | translate"
      [title]="'fmsDiagnose.tabs.cropFields.map.center' | translate"
      data-test="fms-diagnose-map-center"
    >
      <mat-icon aria-hidden="true">visibility</mat-icon>
    </button>

    @if (mapType === 'map') {
      <button
        class="map-control"
        type="button"
        (click)="switchView()"
        [attr.aria-label]="'fmsDiagnose.tabs.cropFields.map.satellite' | translate"
        [title]="'fmsDiagnose.tabs.cropFields.map.satellite' | translate"
        data-test="fms-diagnose-map-view"
      >
        <mat-icon aria-hidden="true">terrain</mat-icon>
      </button>
    } @else {
      <button
        class="map-control"
        type="button"
        (click)="switchView()"
        [attr.aria-label]="'fmsDiagnose.tabs.cropFields.map.view' | translate"
        [title]="'fmsDiagnose.tabs.cropFields.map.view' | translate"
        data-test="fms-diagnose-map-view"
      >
        <mat-icon aria-hidden="true">map</mat-icon>
      </button>
    }

    <div class="map-controls__zoom">
      <button
        class="map-control"
        type="button"
        (click)="zoomIn()"
        [attr.aria-label]="'fmsDiagnose.tabs.cropFields.map.zoomIn' | translate"
        [title]="'fmsDiagnose.tabs.cropFields.map.zoomIn' | translate"
        data-test="fms-diagnose-map-zoom-in"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
      </button>
      <button
        class="map-control"
        type="button"
        (click)="zoomOut()"
        [attr.aria-label]="'fmsDiagnose.tabs.cropFields.map.zoomOut' | translate"
        [title]="'fmsDiagnose.tabs.cropFields.map.zoomOut' | translate"
        data-test="fms-diagnose-map-zoom-out"
      >
        <mat-icon aria-hidden="true">remove</mat-icon>
      </button>
    </div>
  </div>
</div>
